import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { T, t } from '@sm/intl';
import { startCase } from 'lodash';
import { createUseStyles } from 'react-jss';
import { Box } from '@wds/box';
import { SelectMenu } from '@wds/select-menu';
import { Typography } from '@wds/typography';
import { BLUE_CHECK, USE_CASES } from '../../constants';
import { useThemesReuse, useThemesReuseActions } from '../../Context';
export const COPY = {
  label: {
    id: 'OpenEndedCoding.UseCaseFilter.label',
    defaultMessage: 'use case filter',
    description: '[Type: Header][Vis: med] - Use case filter label'
  },
  placeholder: {
    id: 'OpenEndedCoding.UseCaseFilter.placeholder',
    defaultMessage: 'Select Project Type',
    description: '[Type: Header][Vis: med] - Use case filter placeholder'
  },
  none: {
    id: 'OpenEndedCoding.UseCaseFilter.none',
    defaultMessage: 'None of the above',
    description: '[Type: Header][Vis: med] - Use case filter label'
  },
  useCaseHeader: {
    id: 'OpenEndedCoding.UseCaseFilter.useCaseHeader',
    defaultMessage: "What is your project's use case?",
    description: '[Type: Header][Vis: med] - Create Theme Modal use case header'
  },
  useCaseDescription: {
    id: 'OpenEndedCoding.UseCaseFilter.useCaseDescription',
    defaultMessage: 'If you select a use case from below that most closely matches your use case, our AI can suggest themes to add to responses.',
    description: '[Type: Header][Vis: med] - Create Theme Modal use case description'
  }
};
const useStyles = createUseStyles(theme => ({
  selectMenu: {
    // style the check blue
    '& div[class^="wrenchListAddon"] svg': {
      fill: BLUE_CHECK
    },
    // need a narrower select menu trigger
    '& span[class^="wrenchMenuContainer"] > div[class^="wrenchSelectMenu"]': {
      padding: '0px 42px 0px 12px'
    }
  }
}));
const UseCaseSelector = ({
  setPreviousUseCase,
  setShowChangeUseCaseModal
}) => {
  const classes = useStyles();
  const {
    useCases,
    selectedUseCase
  } = useThemesReuse();
  const {
    setSelectedUseCase
  } = useThemesReuseActions();
  const handleUseCaseChange = e => {
    setPreviousUseCase(selectedUseCase);
    setSelectedUseCase(e.currentTarget.getAttribute('data-value'));
    setShowChangeUseCaseModal(true);
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(Box, {
      mb: 4,
      children: [_jsx(Box, {
        mb: 2,
        children: _jsx(Typography, {
          variant: "body",
          weight: "medium",
          children: _jsx(T, {
            desc: COPY.useCaseHeader
          })
        })
      }), _jsx(Box, {
        mb: 2,
        children: _jsx(Typography, {
          component: "p",
          variant: "bodySm",
          children: _jsx(T, {
            desc: COPY.useCaseDescription
          })
        })
      })]
    }), _jsx(Box, {
      className: classes.selectMenu,
      children: _jsx(SelectMenu, {
        addOn: null,
        "data-testid": "UseCaseSelector__Oec",
        ariaLabel: t(COPY.label),
        value: selectedUseCase,
        name: t(COPY.label),
        onChange: handleUseCaseChange,
        placement: "top-left",
        placeholder: t(COPY.placeholder),
        children: useCases.filter(u => selectedUseCase === null ? u !== USE_CASES.none : true).map(u => _jsx(SelectMenu.Option, {
          value: u,
          children: u === USE_CASES.none ? t(COPY.none) : startCase(u)
        }, u))
      })
    })]
  });
};
export default UseCaseSelector;